import React, { useEffect, useRef, useState } from "react";
import { Box, Button, Grid2, styled, useTheme } from "@mui/material";
import { FaPlus } from "react-icons/fa6";
// import { Viewer } from "@xeokit/xeokit-sdk/dist/xeokit-sdk.min.es";
// import { WebIFCLoaderPlugin } from "@xeokit/xeokit-sdk/dist/xeokit-sdk.min.es";
// import { IfcAPI } from "web-ifc";

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

const BimViewer = () => {
    const theme = useTheme();
    const viewerRef = useRef(null);
    const canvasRef = useRef(null);
    const [error, setError] = useState(null);

    // const dummyFiles = [
    //     {
    //         name: 'Duplex.ifc',
    //         url: firstUrl
    //     },
    //     {
    //         name: '1795644778455851009.ifc',
    //         url: secondUrl
    //     }
    // ];

    useEffect(() => {
        // const loadDependencies = async () => {
        //     try {
        //         // Make sure we have a valid canvas element
        //         if (!document.getElementById("xeokit_canvas")) {
        //             console.error("Canvas element not found!");
        //             setError("Canvas initialization failed");
        //             return;
        //         }

        //         console.log("Initializing viewer...");
        //         const viewer = new Viewer({
        //             canvasId: "xeokit_canvas",
        //             transparent: true
        //         });

        //         viewer.camera.eye = [-3.933, 2.855, 27.018];
        //         viewer.camera.look = [4.4, 3.724, 8.899];
        //         viewer.camera.up = [-0.018, 0.999, 0.039];

        //         viewer.scene.xrayMaterial.fillColor = [0.0, 0.0, 1.0];
        //         viewer.scene.xrayMaterial.edgeColor = [0.0, 0.0, 0.0];
        //         viewer.scene.xrayMaterial.fillAlpha = 0.05;
        //         viewer.scene.xrayMaterial.edgeAlpha = 0.3;

        //         console.log("Initializing IFC API...");
        //         const ifcAPI = new IfcAPI();
        //         // Use a reliable CDN path with specific version
        //         ifcAPI.SetWasmPath("https://unpkg.com/web-ifc@0.0.68/");

        //         console.log("Calling Init on IFC API...");

        //         ifcAPI.Init().then(() => {

        //             const ifcLoader = new WebIFCLoaderPlugin(viewer, {
        //                 wasmPath: "https://unpkg.com/web-ifc@0.0.68/",
        //                 WebIFC: { IfcAPI: ifcAPI },
        //                 IfcAPI: ifcAPI
        //             });

        //             // 2
        //             const sceneModel = ifcLoader.load({ // Creates a Node representing the model
        //                 id: "myModel",
        //                 src: firstUrl,
        //                 edges: true,
        //                 saoEnabled: true
        //             });

        //             const t0 = performance.now();

        //             // document.getElementById("time").innerHTML = "Loading model...";

        //             sceneModel.on("loaded", () => {
        //                 viewer.cameraFlight.jumpTo(sceneModel);
        //             });
        //         });
        //         // await ifcAPI.Init();
        //         // console.log("IFC API initialized successfully!");

        //         // console.log("Creating IFC loader plugin...");
        //         // const ifcLoader = new WebIFCLoaderPlugin(viewer, {
        //         //     wasmPath: "https://unpkg.com/web-ifc@0.0.68/",
        //         //     WebIFC: { IfcAPI: ifcAPI },
        //         //     IfcAPI: ifcAPI
        //         // });

        //         // console.log("Setup complete. Saving references...");
        //         // viewerRef.current = { viewer, ifcLoader, lastModel: null };

        //         // Try loading a default model to verify everything works
        //         // Uncomment if you want a default model to load on component mount
        //         /*
        //         if (dummyFiles[0]?.url) {
        //             const sceneModel = ifcLoader.load({
        //                 id: "defaultModel",
        //                 src: dummyFiles[0].url,
        //                 edges: true,
        //                 saoEnabled: true
        //             });
                    
        //             sceneModel.on("loaded", () => {
        //                 viewerRef.current.lastModel = sceneModel;
        //                 viewer.cameraFlight.jumpTo(sceneModel);
        //             });
        //         }
        //         */

        //     } catch (err) {
        //         console.error("Error initializing BIM viewer:", err);
        //         setError(`Failed to initialize: ${err.message}`);
        //     }
        // };

        // // Slight delay to ensure DOM is ready
        // const timer = setTimeout(() => {
        //     loadDependencies();
        // }, 100);

        // return () => {
        //     clearTimeout(timer);
        //     if (viewerRef.current?.viewer) {
        //         viewerRef.current.viewer.destroy();
        //     }
        // };
    }, []);

    const handleFileChange = async (e) => {
    //     const file = e.target.files[0];
    //     if (!file) return;

    //     try {
    //         console.log(`Processing file: ${file.name}`);

    //         if (!viewerRef.current?.ifcLoader) {
    //             setError("Viewer not initialized. Please try again.");
    //             return;
    //         }

    //         // Try to match uploaded file with dummy list
    //         const getFile = dummyFiles?.find((f) => f?.name === file?.name);
    //         const fileURL = getFile?.url || URL.createObjectURL(file);

    //         // Destroy previous model if it exists
    //         if (viewerRef.current.lastModel) {
    //             console.log("Destroying previous model...");
    //             viewerRef.current.lastModel.destroy();
    //             viewerRef.current.lastModel = null;
    //         }

    //         if (fileURL) {
    //             console.log(`Loading IFC from URL: ${getFile ? 'Predefined file' : 'User uploaded file'}`);

    //             const sceneModel = viewerRef.current.ifcLoader.load({
    //                 id: "model_" + Date.now(),
    //                 src: fileURL,
    //                 edges: true,
    //                 saoEnabled: true
    //             });

    //             console.log("Model loading initiated...");

    //             sceneModel.on("loaded", () => {
    //                 console.log("Model loaded successfully!");
    //                 viewerRef.current.lastModel = sceneModel;
    //                 viewerRef.current.viewer.cameraFlight.jumpTo(sceneModel);
    //             });

    //             sceneModel.on("error", (err) => {
    //                 console.error("Error loading model:", err);
    //                 setError(`Failed to load model: ${err.message || "Unknown error"}`);
    //             });
    //         }
    //     } catch (err) {
    //         console.error("Error in file handling:", err);
    //         setError(`Error processing file: ${err.message}`);
    //     }
    };

    return (
        <>
            <Grid2 container spacing={2} sx={{ mt: "20px" }}>
                
                <Grid2 size={12} sx={{ mt: 2 }}>
                    <iframe width="100%" style={{border:0}}
                        height="700px"
                        src=
                        "https://apitest.ingencorp.in/index.php"
                        title="GeeksforGeeks" >
                    </iframe>
                </Grid2>
            </Grid2>
        </>
    );
};

export default BimViewer;